import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { SvgUnifyDirective } from '@app/app/shared/directives/svg-unify-directive';
import { SgInputComponent } from '@app/app/shared/styleguide/components';
import { ButtonComponent } from '@app/app/shared/styleguide/components/buttons/default/button.component';
import { NavItemBaseComponent } from '@app/app/shared/styleguide/components/buttons/nav-item-base/nav-item-base.component';
import { NavItemButtonComponent } from '@app/app/shared/styleguide/components/buttons/nav-item-button/nav-item-button.component';
import { IconComponent } from '@app/app/shared/styleguide/components/icon/icon.component';
import { SgTextareaComponent } from '@app/app/shared/styleguide/components/textarea/sg-textarea/sg-textarea.component';
import { StyleguideDemoComponent } from '@app/app/shared/styleguide/examples/styleguide-demo.component';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { BadgeBaseComponent } from './components/badge/badge-base.component';
import { SgButtonComponent } from './components/buttons/sg-button/sg-button.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { PaginationFooterComponent } from './components/pagination/pagination-footer.component';
import { SgRadioGroupComponent } from './components/radio/sg-radio-group/sg-radio-group.component';
import { SgSelectComponent } from './components/selects/sg-select/sg-select.component';
import { SgToggleComponent } from './components/toggles/sg-toggle/sg-toggle.component';
import { UploadFileAreaComponent } from './components/upload-file-area/upload-file-area.component';

const STYLEGUIDE_COMPONENTS = [
  StyleguideDemoComponent,
  SgButtonComponent,
  SgInputComponent,
  SgTextareaComponent,
  SgToggleComponent,
  SgRadioGroupComponent,
  ButtonComponent,
  NavItemBaseComponent,
  NavItemButtonComponent,
  UploadFileAreaComponent,
  ConfirmationPopupComponent,
  BadgeBaseComponent,
  PaginationFooterComponent,
  SgSelectComponent,
];

const STYLEGUIDE_DIRECTIVES = [SvgUnifyDirective];

@NgModule({
  declarations: [...STYLEGUIDE_COMPONENTS, ...STYLEGUIDE_DIRECTIVES],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatRadioModule,
    MatChipsModule,
    MatCardModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    TranslocoModule,
    HugeiconsIconComponent,
    IconComponent,
    MatLegacyAutocompleteModule,
  ],
  exports: [...STYLEGUIDE_COMPONENTS, ...STYLEGUIDE_DIRECTIVES, IconComponent],
})
export class StyleguideModule {}
